import { timeToArray, capitalize } from './index';

export function getDayHourFormat(timeLeft, config) {
    const [days, hours] = timeToArray(timeLeft);
    // constant used for few/many translation special rules (2: few, 3: many)
    const hoursConst = config.getTimeConstants(hours);

    return { id: 'timeLeft.ticksDayHourFormat', values: { days, hours, hoursConst } };
}

export function getInDayHourFormat(timeLeft, config) {
    const [days, hours] = timeToArray(timeLeft);
    // constant used for few/many translation special rules (2: few, 3: many)
    const hoursConst = config.getTimeConstants(hours);

    return { id: 'timeLeft.ticksDayHourFormatIn', values: { days, hours, hoursConst } };
}

export function getShortDayHourFormat(timeLeft) {
    const [days, hours, minutes] = timeToArray(timeLeft);

    return { id: 'timeLeft.ticksDayHourFormatShort', values: { days, hours, minutes } };
}

export function getTimerFormat(timeLeft) {
    const [, hours, minutes, seconds] = timeToArray(timeLeft);

    const pad2 = (number) => `0${number}`.slice(-2);

    return { id: 'timeLeft.ticksTimerFormat', values: {
        hours,
        minutes: pad2(minutes),
        seconds: pad2(seconds),
    } };
}

export function getShortTimerFormat(timeLeft) {
    const [, hours, minutes, seconds] = timeToArray(timeLeft);

    const pad2 = (number) => `0${number}`.slice(-2);

    return { id: 'timeLeft.ticksTimerFormatShort', values: {
        hours,
        minutes: pad2(minutes),
        seconds: pad2(seconds),
    } };
}

export function getTodayFormat(timeLeft) {
    const date = new Date(new Date().getTime() + 1000 + timeLeft);
    const clockHour = date.getHours();

    return { id: 'timeLeft.ticksTodayFormat', values: { clockHour } };
}

export function getDateTimeFormat(timeLeft, dateTimeFormat, intl) {
    const date = new Date(new Date().getTime() + 1000 + timeLeft);
    const clockHour = date.getHours();
    const clockDate = capitalize(intl.formatDate(date, {
        weekday: dateTimeFormat.weekday || 'short',
        month: dateTimeFormat.month || 'long',
        day: 'numeric'
    }));

    return { id: 'timeLeft.ticksDatetimeFormat', values: { clockDate, clockHour } };
}
